export const CHAT_BACKGROUNDS = [
  {
    id: "harbour",
    title: "Harbour signal",
    detail: "The original quiet Southern Sky surface.",
    image: null,
    appearance: "any",
  },
  {
    id: "midnight-current",
    title: "Midnight current",
    detail: "Deep ocean light and a calm distant horizon.",
    image: "/chat-backgrounds/midnight-current-v1.webp",
    appearance: "night",
  },
  {
    id: "prism-veil",
    title: "Prism veil",
    detail: "Soft violet and jade light around a dark centre.",
    image: "/chat-backgrounds/prism-veil-v1.webp",
    appearance: "night",
  },
  {
    id: "rain-garden",
    title: "Rain garden",
    detail: "A sheltered glass garden after dark.",
    image: "/chat-backgrounds/rain-garden-v1.webp",
    appearance: "night",
  },
  {
    id: "copper-cloud",
    title: "Copper cloud",
    detail: "Warm dusk at the edges of a quiet sky.",
    image: "/chat-backgrounds/copper-cloud-v1.webp",
    appearance: "night",
  },
  {
    id: "moon-archive",
    title: "Moon archive",
    detail: "A quiet illustrated observatory above the clouds.",
    image: "/chat-backgrounds/moon-archive-v1.webp",
    appearance: "night",
  },
  {
    id: "rainline-station",
    title: "Rainline station",
    detail: "An empty animated railway platform after dark.",
    image: "/chat-backgrounds/rainline-station-v1.webp",
    appearance: "night",
  },
  {
    id: "sunroom-linen",
    title: "Sunroom linen",
    detail: "Warm plaster, soft daylight and olive shadows.",
    image: "/chat-backgrounds/sunroom-linen-v1.webp",
    appearance: "light",
  },
  {
    id: "apricot-air",
    title: "Apricot air",
    detail: "Pearl sky framed by gentle peach clouds.",
    image: "/chat-backgrounds/apricot-air-v1.webp",
    appearance: "light",
  },
  {
    id: "celadon-tide",
    title: "Celadon tide",
    detail: "Pale mineral stone with quiet water light.",
    image: "/chat-backgrounds/celadon-tide-v1.webp",
    appearance: "light",
  },
  {
    id: "lavender-glass",
    title: "Lavender glass",
    detail: "Pearl-lilac daylight through translucent veils.",
    image: "/chat-backgrounds/lavender-glass-v1.webp",
    appearance: "light",
  },
  {
    id: "cloudstep-studio",
    title: "Cloudstep studio",
    detail: "A sunlit animation studio above a sea of clouds.",
    image: "/chat-backgrounds/cloudstep-studio-v1.webp",
    appearance: "light",
  },
  {
    id: "peach-soda-coast",
    title: "Peach soda coast",
    detail: "A bright illustrated promenade beside turquoise water.",
    image: "/chat-backgrounds/peach-soda-coast-v1.webp",
    appearance: "light",
  },
] as const;

export type ChatBackgroundId = (typeof CHAT_BACKGROUNDS)[number]["id"];

export function parseChatBackground(value: string | null): ChatBackgroundId {
  return CHAT_BACKGROUNDS.some((background) => background.id === value)
    ? value as ChatBackgroundId
    : "harbour";
}

export function chatBackgroundTitle(value: string | null) {
  const selected = CHAT_BACKGROUNDS.find((background) => background.id === parseChatBackground(value));
  return selected?.title ?? CHAT_BACKGROUNDS[0].title;
}
